<template>
  <in-viewport>
    <div class="projects-section">
      <base-layout hide-sidebar>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <border-box slot="content">
          <ul class="projects-section__list">
            <li
              v-for="(project, i) in projects"
              :key="i"
              class="projects-section__item"
            >
              <span>{{ project.title }}</span>
              <span
                v-if="project.description"
                v-html="project.description"
                class="projects-section__content"
              />
            </li>
          </ul>
        </border-box>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    projects: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .projects-section {
    @include vertical-space((bottom: 1), padding);

    &__list {
      @include reset-list;
      list-style-type: disc;
      list-style-position: inside;
    }

    &__item {
      @include text(big, bold);
      @include vertical-space((bottom: 1));
    }

    &__content {
      @include text(big, medium);
      display: block;
      @include media-up(lg) {
        @include nested-column-width(8, 9, lg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/About/ProjectsSection.vue